import './SiteUnitCommandsPopup.scoped.scss';
import useAlias from '@alias';
import Button from '@components/_elements/Button/Button';
import Input from '@components/_elements/Input/Input';
import FormattedAlias from '@components/_shared/Translations/FormattedAlias';
import storeConnector from '@store/storeConnector';

const ControlLockForm = ({
  popupProps,
  batteryConnectingStatus,
  invStatus,
  LocRemCtl,
  setControllerLockPopupIsOpen,
  setOverInput,
  controllerLockNote,
  setControllerLockNote,
  setControllerLockConfirm,
}) => {
  const alias = useAlias();
  const isUnitRunned = () => {
    if (popupProps.popupType === 'unit') {
      let racksOnline = 0;
      let racks = 0;

      if (batteryConnectingStatus && batteryConnectingStatus.length === 4) {
        racksOnline = parseInt(batteryConnectingStatus.substr(0, 2), 16);
        racks = parseInt(batteryConnectingStatus.substr(2), 16);
      }

      const isStopped =
        ['Ready', 'Off'].includes(invStatus) &&
        LocRemCtl === 'Manual' &&
        racks === racksOnline;

      return !isStopped;
    }

    return false;
  };

  return (
    <div className='cover-container cover-container-confirm'>
      <>
        <div
          className='control-popup-container'
          style={{ padding: '20px 30px' }}
        >
          {!isUnitRunned() ? (
            <div>
              <div>
                <FormattedAlias id='Please ensure unit is stopped and all DC Contactors are OPEN prior to Lockout' />
              </div>
              <div className='popup-row commands-popup-control'>
                <Button
                  size='m'
                  onClick={() => setControllerLockPopupIsOpen(false)}
                >
                  <FormattedAlias id='OK' />
                </Button>
              </div>
            </div>
          ) : (
            <div>
              <div className='loto-reason-row'>
                <span>
                  <FormattedAlias id='Reason for Controls Lock' />
                </span>
                <Input
                  type='text'
                  onMouseEnter={() => setOverInput(true)}
                  onMouseLeave={() => setOverInput(false)}
                  value={controllerLockNote}
                  onChange={(val) => setControllerLockNote(val)}
                  placeholder={alias('Enter reason')}
                />
              </div>
              <div className='popup-row commands-popup-control'>
                <Button
                  disabled={!controllerLockNote}
                  onClick={() => {
                    setControllerLockConfirm(true);
                    setControllerLockPopupIsOpen(false);
                  }}
                >
                  <FormattedAlias id='LOCK CONTROLS' />
                </Button>
                <Button
                  size='m'
                  onClick={() => {
                    setControllerLockNote('');
                    setControllerLockPopupIsOpen(false);
                  }}
                >
                  <FormattedAlias id='CANCEL' />
                </Button>
              </div>
            </div>
          )}
        </div>
      </>
    </div>
  );
};

export default storeConnector(ControlLockForm, {
  service: ['popupProps'],
});
